// extracted by mini-css-extract-plugin
module.exports = {"buttonContainer":"profile-creation-success-component_buttonContainer__1PURT","outerContainer":"profile-creation-success-component_outerContainer__3Untb"};